var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7826 6.24769C13.9487 6.24769 14.0994 6.32019 14.2186 6.44269C14.3296 6.57352 14.3855 6.73602 14.3693 6.90769C14.3693 6.96435 13.9252 12.581 13.6715 14.9451C13.5127 16.3959 12.5774 17.2767 11.1745 17.3009C10.0958 17.3251 9.04136 17.3334 8.00316 17.3334C6.90093 17.3334 5.82302 17.3251 4.77672 17.3009C3.42082 17.2684 2.48474 16.3718 2.33399 14.9451C2.07302 12.5726 1.63699 6.96435 1.62889 6.90769C1.62079 6.73602 1.6759 6.57352 1.78774 6.44269C1.89796 6.32019 2.05681 6.24769 2.22377 6.24769H13.7826ZM9.72061 0.666748C10.4573 0.666748 11.1154 1.18091 11.3059 1.91424L11.442 2.52256C11.5522 3.01839 11.9818 3.36922 12.4762 3.36922H14.9059C15.2301 3.36922 15.5 3.63839 15.5 3.98088V4.29755C15.5 4.63171 15.2301 4.90921 14.9059 4.90921H1.09488C0.769883 4.90921 0.5 4.63171 0.5 4.29755V3.98088C0.5 3.63839 0.769883 3.36922 1.09488 3.36922H3.52464C4.01821 3.36922 4.44775 3.01839 4.55879 2.5234L4.68603 1.95507C4.88378 1.18091 5.53458 0.666748 6.27939 0.666748H9.72061Z",
    fill: "#FF5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5f3f994a4114951f68c3e06587e434ea.svg";
export { ForwardRef as ReactComponent };